const allergyFilterBtns = document.querySelectorAll('[data-allergy-filter]');
const products = document.querySelectorAll('[data-product]');
let activeFilters = []
const filterProducts = () => {
  allergyFilterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.allergyFilter;

      btn.classList.toggle('active');

      // If the filter is already active, remove it
      if (activeFilters.includes(filter)) {
        activeFilters = activeFilters.filter((f) => f !== filter);
      } else {
        // Otherwise, add it
        activeFilters.push(filter);
      }

      products.forEach((product) => {
        const allergyList = product.querySelector("[data-allergy-list]");

        const allergyListData = JSON.parse(allergyList.textContent);
        // Check if the product matches all active filters
        const matchesAllFilters = activeFilters.every(
          (filter) =>
            allergyListData[filter] === "False" || allergyListData[filter] === "True, precaution"
        );

        // If the product does not match all filters, hide it
        if (!matchesAllFilters) {
          product.style.display = "none";
        } else {
          if (window.matchMedia("(max-width: 990px)").matches) {
            product.style.display = "flex";
          } else {
            product.style.display = "table-row";
          }
        }
      });
    });
  });
}

const init = () => {
  filterProducts();
};

init();